<template>
    <div class="country-ca" :class="$x.nsAddressForm">
        <VTextField
            v-model="address.address1"
            name="address1"
            maxlength="45"
            required
            validate-on-blur
            :label="t.address1Label"
            class="flex-column"
            :rules="address1Rules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <VTextField
            v-model="address.address2"
            name="address2"
            maxlength="35"
            validate-on-blur
            class="flex-column"
            :aria-label="t.address2Label"
            :rules="address2Rules"
            @blur="onBlur"
            @input="addressUpdated"
        >
            <template #label>
                {{ t.address2Label }}
                <span :class="$x.optional"> {{ t.optional }} </span>
            </template>
        </VTextField>
        <VTextField
            v-model="address.city"
            name="city"
            maxlength="25"
            required
            validate-on-blur
            :label="t.cityLabel"
            class="flex-column"
            :rules="cityRules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <div :class="$x.dualColumn">
            <NsSelect
                v-model="address.region"
                :items="regions"
                name="region"
                :label="t.regionLabel"
                :rules="stateRules"
                :class="$x.firstCol"
                class="flex-column"
                @blur="onBlur"
                @input="addressUpdated"
            ></NsSelect>
            <VTextField
                v-model="address.postalCode"
                name="postalCode"
                maxlength="7"
                required
                validate-on-blur
                :label="t.postalCodeLabel"
                class="flex-column"
                :class="$x.secondCol"
                :rules="postalCodeRules"
                @blur="onBlur"
                @input="addressUpdated"
            ></VTextField>
        </div>
        <VTextField
            v-if="includeEmail"
            v-model="address.email"
            name="email"
            class="flex-column"
            maxlength="50"
            required
            validate-on-blur
            :label="t.emailLabel"
            :rules="emailRules"
            @input="addressUpdated"
        />
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import {NsSelect} from '@nuskin/design-components';
import ADDRESS_MIXIN from '../addressMixin';
import REGIONS from './regions';
// Most of the logic for this component is in the mixin
import TRANSLATIONS from './translations';

export default {
    name: 'NsAddressCa',
    components: {
        VTextField,
        NsSelect,
    },
    mixins: [ADDRESS_MIXIN],
    data() {
        return {
            regions: REGIONS.sort((a, b) => a.text.localeCompare(b.text)),
        };
    },
    mounted() {
        this.address.country = 'CA';
        if (TRANSLATIONS[this.lang]) {
            this.t = TRANSLATIONS[this.lang];
        } else {
            // If the language isn't available then get the first language in translations file
            this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
        }
        this.$emit('new-address-in-form');
    },
    methods: {},
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

$color-eeyore: map.get(colors.$baseColors, eyore);

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.nsAddressForm {
  .dualColumn {
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 480px) {
      flex-flow: row wrap;
    }
    flex-flow: row wrap;

    .firstCol {
      margin-right: 20px;
      width: calc(70% - 20px);
      @media screen and (max-width: 480px) {
        margin-right: 0;
        width: 100%;
      }
    }
    .secondCol {
      width: 30%;
      max-width: 160px;
      @media screen and (max-width: 480px) {
        width: 100%;
      }
    }
  }
}

.optional {
  color: $color-eeyore;
}
</style>
